import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AuthCallback from './pages/AuthCallback';
import Settings from './pages/Settings';
import WealthPlanner from './pages/WealthPlanner';
import AdminDashboard from './pages/AdminDashboard';
import LLCCalculator from './pages/LLCCalculator';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import TaxSnapshot from './pages/TaxSnapshot';
import ChartRoom from './pages/ChartRoom';
import TradeRoom from './pages/TradeRoom';
import ClaimPatreon from './pages/ClaimPatreon';
import TraderDesk from './pages/TraderDesk';
import { AuthProvider, useAuth } from './context/AuthContext';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  const [redirecting, setRedirecting] = React.useState(false);
  React.useEffect(() => {
    if (user && user.subscription_tier === "free" && !user.chart_room_access && !user.patreon_tier && !redirecting && !window.location.search.includes("upgraded=true") && !window.location.search.includes("reactivate=")) {
      setRedirecting(true);
      const token = localStorage.getItem("token");
      const billing = new URLSearchParams(window.location.search).get("billing") || "monthly";
      fetch("/api/stripe/create-checkout", { method: "POST", headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token }, body: JSON.stringify({ tier: "premium", billing }) })
        .then(r => r.json())
        .then(d => { if (d.url) window.location.href = d.url; })
        .catch(() => {});
    }
  }, [user, redirecting]);
  if (loading || redirecting) return <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh"}}>Loading...</div>;
  if (!user) {
    const current = window.location.pathname + window.location.search;
    if (current !== '/login') localStorage.setItem('intended_url', window.location.href);
    return <Navigate to="/login" />;
  }
  return children;
}
function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh"}}>Loading...</div>;
  if (user.email !== "xrprightnow@gmail.com") return <Navigate to="/dashboard" />;
  return children;
}

function ProRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh"}}>Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  if (user.subscription_tier === "free") return <Navigate to="/dashboard?upgrade=true" />;
  return children;
}
function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh'}}>Loading...</div>;
  return !user ? children : <Navigate to="/dashboard" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/onboarding" element={<PrivateRoute><Onboarding /></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/tax" element={<PrivateRoute><TaxSnapshot /></PrivateRoute>} />
          <Route path="/llc" element={<ProRoute><LLCCalculator /></ProRoute>} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/wealth" element={<ProRoute><WealthPlanner /></ProRoute>} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="/chart-room" element={<ChartRoom />} />
          <Route path="/trade-room" element={<TradeRoom />} />
          <Route path="/claim-patreon" element={<ClaimPatreon />} />
          <Route path="/trader" element={<TraderDesk />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
